module.exports = __webpack_public_path__ + "static/media/creative-commons-sampling-plus.80e20687.svg";